import React from 'react'

const HeaderCompo = ({ tagType, text, className, children }) => {
    if (tagType === "h1") { return (<> {<h1 className={className}>{text}{children}</h1>} </>) } else
        if (tagType === "h2") { return (<> {<h2 className={className}>{text}{children}</h2>} </>) } else
            if (tagType === "h3") { return (<> {<h3 className={className}>{text}{children}</h3>} </>) } else
                if (tagType === "h4") { return (<> {<h4 className={className}>{text}{children}</h4>} </>) } else
                    if (tagType === "h5") { return (<> {<h5 className={className}>{text}{children}</h5>} </>) } else
                        if (tagType === "h6") { return (<> {<h6 className={className}>{text}{children}</h6>} </>) }
}

export default HeaderCompo